import styled from "styled-components";

export const AppContainer = styled.div`
  display: flex;
  min-height: 100vh;
`;

export const NavBarContainer = styled.div`
  width: 250px;
  min-width: 250px;
  background-color: rgba(30, 30, 44, 1);
  /* background-color : blue; */
`;

export const MainContent = styled.div`
  flex: 1;
  min-width: 0;
  background-color: #f6f6f6;
  /* padding: 20px; */
`;

export const StandaloneContent = styled.main`
  min-height: 100vh;
  background-color: #f6f6f6;
`;

export const NotFoundContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 24px;
  text-align: center;
`;

export const NotFoundCode = styled.h1`
  margin: 0;
  font-size: 80px;
  font-weight: 700;
  color: #1e1e2c;
`;

export const NotFoundTitle = styled.h2`
  margin: 12px 0 0;
  font-size: 28px;
  color: #1e1e2c;
`;

export const NotFoundDescription = styled.p`
  margin: 12px 0 0;
  font-size: 16px;
  color: #666;
`;

export const NotFoundActionButton = styled.button`
  margin-top: 24px;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  background-color: #1e1e2c;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background-color: #2d2d44;
  }
`;
